/**
 * Constants for CleaningStandardsDrawer (sections, days, device mapping, initial state).
 * Single place for drawer configuration (DRY, maintainability).
 */

import { createDefaultSession } from '../../../utils/sessionMigrations';

export const SECTION_ORDER = ['cleaning-window', 'cleaning-processes', 'other-tasks'];

export const SECTION_NAMES = {
  'cleaning-window': 'Cleaning Window',
  'cleaning-processes': 'Cleaning Processes',
  'other-tasks': 'Other Cleaning Tasks',
};

export const DAYS = [
  { short: 'M', full: 'Monday' },
  { short: 'T', full: 'Tuesday' },
  { short: 'W', full: 'Wednesday' },
  { short: 'T', full: 'Thursday' },
  { short: 'F', full: 'Friday' },
  { short: 'S', full: 'Saturday' },
  { short: 'S', full: 'Sunday' },
];

export const DEVICE_PROCESS_MAP = {
  V50: 'VACUUMING',
  MS50: 'MOPPING',
  A50: 'SCRUBBING',
};

export const DEFAULT_WINDOW_ID = 'window-1';

/**
 * Creates the initial cleaning window object used when no standards exist.
 * @returns {Object} Initial window shape for drawer state
 */
export function createInitialWindow() {
  return {
    id: DEFAULT_WINDOW_ID,
    name: 'Window 1',
    days: [],
    sessionType: 'single',
    sessions: [createDefaultSession()],
    cleaningProcesses: [],
  };
}
